import React, { useState } from 'react'
import Controllers from '../../Api/Controllers'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const btnPrimary = {
    borderRadius: 10,
    fontWeight: 700,
    minHeight: 38,
    padding: '0 14px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
}

const btnSecondary = {
    borderRadius: 10,
    fontWeight: 700,
    minHeight: 38,
    padding: '0 14px',
    background: '#F9FAFB',
    color: '#201030',
    border: '1px solid #E5E7EB',
    cursor: 'pointer'
}

const btnReply = {
    background: 'none',
    border: 'none',
    color: '#FF152A',
    fontWeight: 700,
    fontSize: '0.82rem',
    padding: 0,
    cursor: 'pointer'
}

const Comment = ({ comment, onSuccess }) => {
    const [response, setResponse] = useState(false)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [row, setRow] = useState({
        p_id_article: comment.id_article,
        p_id_comment_parent: comment.id_comment,
        p_description_comment: ''
    })

    const handleSubmitComment = ({ data }) => {
        setLoadSubmit(true)
        Controllers.comment.comment_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            setLoadSubmit(false)
            setResponse(false)
            setRow({ ...row, p_description_comment: '' })
            onSuccess()
        })
    }

    return (
        <div className="sp-comment-card">
            <div className="sp-comment-author">
                <div style={{ position: 'relative' }}>
                    <img
                        src={Helpers.config.resourcesUrl({ url: comment.file_photo_cust })}
                        width="36"
                        height="36"
                        alt=""
                        style={{ borderRadius: 999, objectFit: 'cover' }}
                        onError={avatarFallback}
                    />
                    <span className="sp-avatar-fallback" style={{ display: 'none', width: 36, height: 36 }}>
                        <i className="fa fa-user" />
                    </span>
                </div>
                <div>
                    <strong>{comment.full_name_cust}</strong>
                    <div className="sp-comment-meta">{comment.date_created}</div>
                </div>
            </div>
            <p style={{ margin: '0 0 10px', color: '#374151', fontSize: '0.9rem' }}>{comment.description_comment}</p>

            {!response ? (
                <button type="button" onClick={_ => setResponse(true)} style={btnReply}>
                    Responder
                </button>
            ) : (
                <FormCustom dataSubmit={row} className="mt-2" viewSubmit={false} onSubmit={handleSubmitComment}>
                    <TextArea
                        text="Tu respuesta"
                        classNameParent="col-12"
                        rows="4"
                        required
                        value={row.p_description_comment}
                        onChange={e => setRow({ ...row, p_description_comment: e.currentTarget.value })}
                    />
                    <div className="col-12 mt-2 d-flex" style={{ gap: 8 }}>
                        <button type="submit" style={btnPrimary}>
                            {loadSubmit
                                ? <i className="fa fa-circle-notch fa-spin" />
                                : <><i className="fa fa-check" />Enviar</>}
                        </button>
                        <button type="button" style={btnSecondary} onClick={_ => setResponse(false)}>
                            Cancelar
                        </button>
                    </div>
                </FormCustom>
            )}

            {comment.comments_child?.length ? (
                <div className="mt-3" style={{ paddingLeft: 12, borderLeft: '2px solid #E5E7EB' }}>
                    {React.Children.toArray(comment.comments_child.map(c => (
                        <section className="d-flex mb-3" style={{ gap: 10 }}>
                            <div style={{ position: 'relative' }}>
                                <img
                                    src={Helpers.config.resourcesUrl({ url: c.file_photo_cust })}
                                    width="30"
                                    height="30"
                                    alt=""
                                    style={{ borderRadius: 999, objectFit: 'cover' }}
                                    onError={avatarFallback}
                                />
                                <span className="sp-avatar-fallback" style={{ display: 'none', width: 30, height: 30 }}>
                                    <i className="fa fa-user" />
                                </span>
                            </div>
                            <div>
                                <strong style={{ fontSize: '0.84rem', color: '#201030' }}>{c.full_name_cust}</strong>
                                <div className="sp-comment-meta">{c.date_created}</div>
                                <p style={{ margin: '4px 0 0', fontSize: '0.86rem', color: '#374151' }}>{c.description_comment}</p>
                            </div>
                        </section>
                    )))}
                </div>
            ) : null}
        </div>
    )
}

export default Comment
